import React, { useState } from 'react'
import Menu from '../components/Menu/Menu';
import Navbar from '../components/Navbar/Navbar';
import "../App.css";
import DashboardHome from './DashboardHome';

function Dashboard({dashboardChildren}) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Function to toggle the menu visibility
    const toggleMenu = () => {
      setIsMenuOpen((prevState) => !prevState);
    };
  
  return (
    <div
      class={`page-wrapper ${isMenuOpen?'show-sidebar mini-sidebar':''}`}
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin6"
      data-sidebartype={`${isMenuOpen?'mini-sidebar':'full'}`}
      data-sidebar-position="fixed"
      data-header-position="fixed"
      style={{overflow:"hidden"}}
    >
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu}/>
      <div className="body-wrapper">
        <Navbar isMenuOpen={isMenuOpen} toggleMenu={toggleMenu}/> 
        {dashboardChildren}
      </div> 
        
    </div>
  )
}

export default Dashboard